const location = null;

export default location;
